import { Alarm } from "../CRUDs/entities/Alarm";
import accidents from "./accidents";

export default {
    init() {
        accidents.sort_date('alarms__table-box-img');
        //accidents.filterType('alarms__header-filter-box-select');
        this.alarmStatusModalCallerClick();
        this.alarmStatus();
        this.listeners()
    },

    listeners(){
        $('body').off('click', '.data-view.alarms .data-row .edit')
                .on('click', '.data-view.alarms .data-row .edit', ev=>{
            new Alarm($(ev.currentTarget).data('alarm_id')).openModal('edit',{},false);
        })
    },

    alarmStatusModalCallerClick(){
        $('.alarm_status').click(function (e){
            let alarmId = $(e.target).parent().find('.alarm_id').data('alarm-id');
            $('#alaram_done').data('alarm-id', alarmId);
        });
    },

    alarmStatus (){
        $('#alaram_done').click(function (e){
            let element = $(this);
            let alarmId = element.data('alarm-id');
            $.ajax({
                url: '/vehicles-management/alarms/update-status-alarm/' + alarmId,
                type: 'GET',
                success: function (res){
                    window.location.reload();
                }
            });
        });
    },
}
